import { CROPS, PACKING, MOLASSES } from '../../data/agricultureContent';

const IMG = '/assets/img';

export const sectors = [
  {
    slug: 'manufacturing',
    route: '/sectors/manufacturing',
    navLabel: { ar: 'قطاع التصنيع', en: 'Manufacturing Sector' },
    metaTitle: { ar: 'قطاع التصنيع — مجموعة الهواري', en: 'Manufacturing Sector — Elhaware Group' },
    heroSlides: [`${IMG}/Pngtreejar_of_molasses_with_thick_15923562.webp`, `${IMG}/factory-packing.webp`],
    heroTitle: {
      before: { ar: 'قطاعٌ هو ', en: 'The Sector That Is ' },
      bold: { ar: 'قاطرة المجموعة', en: "the Group's Engine" },
      after: { ar: '', en: '' },
    },
    heroLead: {
      ar: 'قاطرة المجموعة الاقتصادية والمموّل الرئيسي للتوسّع في كافة القطاعات — حيث تُعدّ المجموعة أكبر منتجٍ للعسل الأسود المحوّل الصناعي في مصر وواجهة صناعته في نجع حمادي.',
      en: "The economic engine of the group and the principal financier of expansion across every sector — Elhaware Group is the largest producer of converted molasses in Egypt and the leading name in the industry in Nag Hammadi.",
    },
    introParas: [
      {
        ar: 'هي نقطة بداية المجموعة، حيث تعود خبرة مؤسسيها إلى عام 1970، حين امتلك السيد محمود محمد أفضل عصارات قصب السكر وإنتاج العسل الأسود في سوهاج وقنا ومنذ ذلك الحين بدأت المسيرة في إنتاج العسل الأسود.',
        en: "It serves as the starting point of the group, with the founders' expertise dating back to 1970 when Mr. Mahmoud Mohamed owned the best sugarcane presses and produced molasses in Sohag and Qena. Since then, the journey in molasses production began.",
      },
      {
        ar: 'قطاع التصنيع هو قاطرة المجموعة الاقتصادية والمموّل الرئيسي للتوسّع في كافة القطاعات؛ فالمجموعة تُعدّ أكبر منتجٍ للعسل الأسود المحوّل الصناعي في مصر، والواجهة الرئيسية والمسيطرة في منطقة نجع حمادي حيث يتمركز أكبر وأشهر منتجي العسل الأسود في العالم، وأحد أهم عملاء كبرى شركات السكر المصرية.',
        en: 'The Manufacturing Sector is the economic engine of the group and the principal financier of expansion across every sector. Elhaware Group is the largest producer of converted molasses in Egypt and the leading, dominant presence in Nag Hammadi — home to the largest and most renowned black-honey producers in the world — as well as a key client of Egypt\'s major sugar companies.',
      },
      {
        ar: 'يمثّل القطاع أكبر داعمٍ لقدرة المجموعة على اختراق الأسواق، ونقطة ارتكازٍ لباقي أنشطتها — وأهمها سوق الأعلاف، والقوة المحرّكة لتروس التكامل، وأساس تصنيع المخصّبات والأسمدة الزراعية، بما يوفّر ميزةً نسبية في استيعاب المواصفات المختلفة وتلبية احتياجات العملاء.',
        en: "The sector is the strongest enabler of the group's market reach and the anchor for its other activities — most notably the animal-feed market — driving the gears of integration and forming the foundation for manufacturing fertilizers. This delivers a comparative advantage in meeting diverse specifications and customer needs.",
      },
    ],
    introImg: `${IMG}/manifacture-image-01.webp`,
    badge: {
      big: '#1',
      text: { ar: 'أكبر منتج للعسل الأسود المحوّل الصناعي في مصر', en: 'The largest producer of industrially processed molasses in Egypt.' },
    },
    companies: [
      {
        img: `${IMG}/turkish-mulberry-confiture-molasses-pekmez-and-mulberries.webp`,
        title: { ar: 'الهواري للعسل الأسود (البلدي)', en: 'Elhaware for Black Honey (Baladi)' },
        desc: {
          ar: 'إنتاج وتسويق العسل الأسود البلدي؛ الشركة الأم الحاضنة لكافة استثمارات المجموعة.',
          en: "Production and marketing of traditional baladi black honey; the parent company that incubates all of the group's investments.",
        },
      },
      {
        img: `${IMG}/Pngtreejar_of_molasses_with_thick_15923562.webp`,
        title: { ar: 'الهواري للعسل المحوّل المولاس', en: 'Elhaware for Converted Molasses' },
        desc: {
          ar: 'الشركة الرائدة رقم (1) بصعيد مصر في صناعة العسل الأسود الصناعي المحوّل (المولاس).',
          en: 'The number-one company in Upper Egypt for manufacturing industrial converted black honey (molasses).',
        },
      },
      {
        img: `${IMG}/animal-feed-products.webp`,
        title: { ar: 'تصنيع الأعلاف', en: 'Animal Feed Manufacturing' },
        desc: {
          ar: 'مصنع العصر للأعلاف بنجع حمادي بطاقة 5000 طن شهرياً من أعلاف الدواجن والمواشي.',
          en: 'Al-Asr feed plant in Nag Hammadi with a capacity of 5,000 tons per month of poultry and cattle feed.',
        },
      },
      {
        img: `${IMG}/mfg-pesticide.webp`,
        title: { ar: 'المبيدات والتسميد الزراعي', en: 'Pesticides & Agricultural Fertilizing' },
        desc: {
          ar: 'جرين لإنتاج وتسويق المخصّبات والأسمدة الزراعية والمبيدات الحشرية والفطرية.',
          en: 'Green, for producing and marketing fertilizers and insecticidal and fungicidal pesticides.',
        },
      },
    ],
    molasses: MOLASSES,
  },
  {
    slug: 'poultry',
    route: '/sectors/poultry-livestock',
    navLabel: { ar: 'القطاع الداجني والحيواني', en: 'Poultry & Livestock Sector' },
    metaTitle: { ar: 'القطاع الداجني والحيواني — مجموعة الهواري', en: 'Poultry & Livestock Sector — Elhaware Group' },
    heroSlides: [`${IMG}/Screenshot_2026-06-28_at_12.28.14_PM.webp`, `${IMG}/lvs-dairy.webp`, `${IMG}/lvs-goats-sheep.webp`],
    heroTitle: {
      before: { ar: 'الترس ', en: 'The Main ' },
      bold: { ar: 'الرئيسي', en: 'Gear' },
      after: { ar: ' للتكامل', en: ' of Integration' },
    },
    heroLead: {
      ar: 'رافعةٌ للقيمة المضافة للقطاع الزراعي، تستهدف توطين وتطوير السلالات الأعلى إنتاجية وتحويل علاقة المجموعة من قطاع الأعمال إلى المستهلك النهائي.',
      en: "A lever for the agricultural sector's added value, focused on localizing and developing higher-yield breeds and shifting the group's relationship from business-to-business toward the end consumer.",
    },
    introParas: [
      {
        ar: 'يُعدّ القطاع الداجني والحيواني رافعةً للقيمة المضافة للقطاع الزراعي؛ فالمجموعة لا تكتفي بتحقيق الإنتاج وفق المعدلات التشغيلية، بل تستهدف توطين وتطوير السلالات الأعلى إنتاجية — خاصةً المواشي والأغنام في الصعيد — لتعظيم الربحية وضمان عائدٍ اقتصادي للقطاع الزراعي ككل.',
        en: "The Poultry & Livestock Sector is a lever for the agricultural sector's added value. The group does not settle for meeting standard operating output; it sets out to localize and develop higher-yield breeds — especially cattle and sheep in Upper Egypt — to maximize profitability and secure an economic return for the agricultural sector as a whole.",
      },
      {
        ar: 'هو الترس الرئيسي في تكامل أنشطة المجموعة؛ القادر وحده على تحويل المنتجات الثانوية وفواقد التشغيل إلى لحومٍ وألبانٍ وجلودٍ وبيض، والقاعدة التي تنقل علاقة المجموعة إلى المستهلك النهائي، وذراعٌ رئيسي للتوسّع وتثبيت القواعد الخارجية والمسؤولية الاجتماعية.',
        en: "It is the main gear in the integration of the group's activities — the only one able to convert by-products and operating residue into meat, dairy, hides and eggs. It is the base that carries the group's relationship through to the end consumer, and a key arm for expansion, establishing overseas footholds and social responsibility.",
      },
    ],
    introImg: `${IMG}/Screenshot_2026-06-28_at_12.27.30_PM.webp`,
    badge: {
      big: { ar: '1 مليون', en: '1 Million' },
      text: { ar: 'طائر مستهدف للتسمين المكثّف بالصعيد', en: 'Birds targeted for intensive fattening in Upper Egypt' },
    },
    companies: [
      {
        img: `${IMG}/Screenshot_2026-06-28_at_12.28.14_PM.webp`,
        title: { ar: 'محطات الدواجن', en: 'Poultry Stations' },
        desc: {
          ar: 'محطات تسمين بنظام البطاريات في الصعيد، مع تكامل الأمهات والمفرّخات والمجازر والتصنيع.',
          en: 'Battery-system fattening stations in Upper Egypt, integrated with breeders, hatcheries, slaughterhouses and processing.',
        },
      },
      {
        img: `${IMG}/lvs-dairy.webp`,
        title: { ar: 'مزارع المواشي', en: 'Cattle Farms' },
        desc: {
          ar: 'مزارع تربية وتسمين المواشي وإنتاج اللحوم والألبان بأعلى المعدلات.',
          en: 'Farms for raising and fattening cattle and producing meat and dairy at the highest yields.',
        },
      },
      {
        img: `${IMG}/lvs-goats-sheep.webp`,
        title: { ar: 'تطوير الماعز والأغنام', en: 'Goat & Sheep Development' },
        desc: {
          ar: 'توطين وتطوير سلالات الماعز والأغنام الأعلى إنتاجية في بيئة الصعيد.',
          en: 'Localizing and developing higher-yield goat and sheep breeds suited to the Upper Egypt environment.',
        },
      },
    ],
  },
  {
    slug: 'agricultural',
    route: '/sectors/agricultural-production',
    navLabel: { ar: 'قطاع الإنتاج الزراعي', en: 'Agricultural Production Sector' },
    metaTitle: { ar: 'قطاع الإنتاج الزراعي — مجموعة الهواري', en: 'Agricultural Production Sector — Elhaware Group' },
    heroSlides: [`${IMG}/img_bbb48514c78d.webp`, `${IMG}/img_81f9cdf6a82d.webp`],
    heroTitle: {
      before: { ar: 'القاعدة ', en: 'The Core ' },
      bold: { ar: 'الأساسية', en: 'Foundation' },
      after: { ar: ' للقيمة', en: ' of Value' },
    },
    heroLead: {
      ar: 'نقطة انطلاق سلسلة القيمة — استصلاح الأراضي وتنميتها وإنتاج الحاصلات بأساليب علمية حديثة تغذّي كل قطاعات المجموعة.',
      en: "The starting point of the value chain — land reclamation and development and crop production using modern scientific methods that feed every one of the group's sectors.",
    },
    introParas: [
      {
        ar: 'يُعد قطاع الإنتاج الزراعي الركيزة الأساسية لمنظومة الهواري جروب، ونقطة الانطلاق التي تُبنى عليها سلسلة القيمة المتكاملة. نعتمد على استصلاح الأراضي وتنميتها، وإنتاج محاصيل زراعية عالية الجودة وفق أحدث الممارسات الزراعية، بما يتوافق مع طبيعة البيئة ويحقق أعلى مستويات الكفاءة والإنتاجية.',
        en: "The agricultural production sector is the cornerstone of the El-Haware Group system and the starting point upon which the integrated value chain is built. We rely on land reclamation and development, and the production of high-quality agricultural crops according to the latest agricultural practices, in harmony with the nature of the environment and achieving the highest levels of efficiency and productivity.",
      },
      {
        ar: 'ويمثل هذا القطاع الأساس الذي يدعم مختلف أنشطة المجموعة، بدءًا من تصدير أجود الأصناف من الفاكهة والخضروات، إلى تصنيع وتجارة الأعلاف واستخدامها في الإنتاج الحيواني الخاص بالمجموعة، مما يحقق تكاملًا يعزز الجودة، ويخفض التكاليف والمخاطر، ويزيد من القيمة المضافة في جميع مراحل الإنتاج.',
        en: "This sector represents the foundation that supports various activities of the group, starting from exporting the finest varieties of fruits and vegetables, to the manufacturing and trading of feed and its use in the group's livestock production, achieving integration that enhances quality, reduces costs and risks, and increases added value at all stages of production.",
      },
    ],
    introImg: `${IMG}/vegetables.webp`,
    badge: {
      big: { ar: 'تكامل', en: 'Integration' },
      text: { ar: ' أفقي و رأسي يغذّي قطاعات التصنيع والأعلاف والإنتاج الحيواني', en: 'Vertical, feeding the manufacturing, animal-feed and livestock sectors' },
    },
    companies: [
      {
        img: `${IMG}/img_8fbabc2ce2e4.webp`,
        logo: true,
        title: { ar: 'الهواري للتنمية الزراعية', en: 'Elhaware for Agricultural Development' },
        desc: {
          ar: 'التنمية الزراعية وإنتاج الحاصلات بأساليب علمية حديثة عبر أراضي ومزارع المجموعة.',
          en: "Agricultural development and crop production using modern scientific methods across the group's lands and farms.",
        },
      },
      {
        img: `${IMG}/img_9365e97198a2.webp`,
        logo: true,
        title: { ar: 'كراست لاستصلاح الأراضي', en: 'Karast for Land Reclamation' },
        desc: {
          ar: 'استصلاح الأراضي وتجهيزها للإنتاج الزراعي وتوسيع الرقعة المزروعة ضمن خطط المجموعة.',
          en: "Reclaiming and preparing land for agricultural production and expanding the cultivated area within the group's plans.",
        },
      },
    ],
    crops: CROPS,
    packing: PACKING,
  },
  {
    slug: 'logistics',
    route: '/sectors/logistics',
    navLabel: { ar: 'قطاع الخدمات اللوجستية', en: 'Logistics Services Sector' },
    metaTitle: { ar: 'قطاع الخدمات اللوجستية — مجموعة الهواري', en: 'Logistics Services Sector — Elhaware Group' },
    heroSlides: [`${IMG}/truck-elhaware-1.webp`, `${IMG}/truck-elhaware-2.webp`, `${IMG}/truck-elhaware-3.webp`, `${IMG}/truck-elhaware-4.webp`],
    heroTitle: {
      before: { ar: 'العمود ', en: 'The Supply ' },
      bold: { ar: 'الفقري', en: 'Backbone' },
      after: { ar: ' للإمداد', en: '' },
    },
    heroLead: {
      ar: 'أسطولٌ من وحدات النقل الثقيل ونقل السوائل والمولاس والزيوت والمنتجات البترولية يضمن انسيابية سلسلة الإمداد من المزرعة والمصنع إلى السوق.',
      en: 'A fleet of heavy-transport units carrying liquids, molasses, oils and petroleum products, ensuring a smooth supply chain from the farm and the factory to the market.',
    },
    introParas: [
      {
        ar: 'يمثّل قطاع الخدمات اللوجستية العمود الفقري لحركة المنتجات بين قطاعات المجموعة وأسواقها؛ بأسطولٍ من وحدات النقل الثقيل ونقل السوائل والمولاس والزيوت والمنتجات البترولية بطاقةٍ تشغيلية تبلغ 1000 طن.',
        en: "The Logistics Services Sector is the backbone of product movement between the group's sectors and its markets, with a fleet of heavy-transport units carrying liquids, molasses, oils and petroleum products at an operating capacity of 1,000 tons.",
      },
      {
        ar: 'تمتلك المجموعة أيضاً برادات نديرها بكفاءة لضمان وصول منتجاتنا من الحاصلات الزراعية والفاكهة بجودة عالية للأسواق العربية.',
        en: "The group also owns refrigerators that we manage efficiently to ensure our agricultural products and fruits reach the Arab markets with high quality."
      },
      {
        ar: 'يضمن القطاع كفاءة التشغيل وانسيابية سلسلة الإمداد من المزرعة والمصنع إلى السوق، مدعوماً بوحدة موازينٍ معتمدة ترفع من دقة العمليات وموثوقيتها.',
        en: 'The sector guarantees operational efficiency and a smooth supply chain from the farm and the factory to the market, backed by a certified weighbridge unit that raises the accuracy and reliability of operations.',
      },
    ],
    introImg: `${IMG}/truck-elhaware-3.webp`,
    badge: {
      big: { ar: '1000 طن', en: '1,000 Tons' },
      text: { ar: 'الطاقة التشغيلية لأسطول النقل والمواد السائلة', en: 'Operating capacity of the transport and liquid-materials fleet' },
    },
    companies: [
      {
        img: `${IMG}/Heavy-transport.webp`,
        title: { ar: 'الهواري للنقل الثقيل والمواد السائلة', en: 'Elhaware for Heavy Transport & Liquid Materials' },
        desc: {
          ar: 'نقل السوائل والمولاس والزيوت والمنتجات البترولية بطاقة 1000 طن عبر وحدات نقلٍ ثقيل ونصف نقل.',
          en: 'Transporting liquids, molasses, oils and petroleum products at a capacity of 1,000 tons via heavy-transport units and semi-trailers.',
        },
      },
      {
        img: `${IMG}/truck-elhaware-2.webp`,
        title: { ar: 'اسطول ثلاجات الهواري', en: 'Elhaware Weighbridges' },
        desc: {
          ar: 'ما الذي يجعلنا مختلفين؟ إنه أسطولنا من الثلاجات الحديثة التي تضمن أعلى مستوى من الكفاءة ونضارة محاصيلنا وفواكهنا في جميع الدول العربية والخليج.',
          en: "What makes us different? It is our fleet of modern refrigerators that ensure the highest level of efficiency and freshness of our crops and fruits throughout all Arab countries and the Gulf.",
        },
      },
      {
        img: `${IMG}/log-weighbridge.webp`,
        title: { ar: 'موازين الهواري', en: 'Elhaware Weighbridges' },
        desc: {
          ar: 'وحدة موازين معتمدة ضمن منظومة الخدمات اللوجستية، تخدم عمليات النقل والتشغيل للمجموعة.',
          en: "A certified weighbridge unit within the logistics services system, serving the group's transport and operations.",
        },
      },
    ],
  },
  {
    slug: 'commercial',
    route: '/sectors/commercial',
    navLabel: { ar: 'القطاع التجاري', en: 'Commercial Sector' },
    metaTitle: { ar: 'القطاع التجاري — مجموعة الهواري', en: 'Commercial Sector — Elhaware Group' },
    heroSlides: [`${IMG}/com-port.webp`, `${IMG}/com-containers.webp`, `${IMG}/com-produce-trucks.webp`],
    heroTitle: {
      before: { ar: 'رأس ', en: 'The Spearhead ' },
      bold: { ar: 'حربة', en: 'of Market' },
      after: { ar: ' الاختراق', en: ' Penetration' },
    },
    heroLead: {
      ar: 'قاطرة قياس الجدوى ومُفعّل خطط التطوير، المسؤول عن سرعة دوران رأس المال وتعظيم العائد، وبوابة المجموعة إلى الأسواق الخارجية.',
      en: "The engine for measuring feasibility and activating development plans, responsible for the velocity of capital turnover and maximizing returns, and the group's gateway to overseas markets.",
    },
    introParas: [
      {
        ar: 'يُعدّ القطاع التجاري رأس حربة المجموعة في اختراق السوق والتعرّف عليه داخلياً وخارجياً، وقاطرة قياس الجدوى ومُفعّل خطط التطوير، والمسؤول عن سرعة دوران رأس المال وتعظيم العائد من كافة الموارد.',
        en: "The Commercial Sector is the group's spearhead for penetrating and understanding the market both at home and abroad, the engine for measuring feasibility and activating development plans, and the function responsible for the velocity of capital turnover and maximizing returns from all resources.",
      },
      {
        ar: 'تعاظمت أهميته مع استهداف الأسواق الخارجية عبر عمليات التصدير والفروع والشركات الخارجية؛ وقد تبنّت المجموعة مركزية العمليات التجارية إلى جانب التسويق المنفرد لكل نشاط، استفادةً من وفورات التكامل بين عمليات الشراء والبيع في إطارٍ من العمليات المتكافئة.',
        en: 'Its importance has grown with the push into overseas markets through export operations, branches and foreign subsidiaries. The group has adopted centralized commercial operations alongside dedicated marketing for each activity, capturing the efficiencies of integration between buying and selling within a framework of balanced operations.',
      },
    ],
    introImg: `${IMG}/com-ship.webp`,
    badge: {
      big: { ar: '6 دول', en: '6 Countries' },
      text: { ar: 'أسواق تصدير عبر فروع المجموعة الخارجية', en: "Export markets through the group's overseas branches" },
    },
    companies: [
      {
        img: `${IMG}/com-market.webp`,
        title: { ar: 'التجاري والمحلي', en: 'Commercial & Domestic' },
        desc: {
          ar: 'التجارة المحلية وتوزيع منتجات المجموعة داخل السوق المصري عبر شبكةٍ من المنافذ والوكلاء.',
          en: "Domestic trade and distribution of the group's products within the Egyptian market through a network of outlets and agents.",
        },
      },
      {
        img: `${IMG}/com-ship.webp`,
        title: { ar: 'التصدير وتطوير الأعمال', en: 'Export & Business Development' },
        desc: {
          ar: 'التصدير وفتح أسواقٍ جديدة لمنتجات المجموعة عربياً وأفريقياً وأوروبياً.',
          en: "Export and opening new markets for the group's products across the Arab world, Africa and Europe.",
        },
      },
      {
        img: `${IMG}/com-premium-produce.webp`,
        title: { ar: 'مبارك السعودي للاستثمار الزراعي', en: 'Mubarak Saudi for Agricultural Investment' },
        desc: {
          ar: 'شراكة استراتيجية بالسعودية (2025) لتوريد أجود المحاصيل والمنتجات المصرية للسوق السعودي.',
          en: 'A strategic partnership in Saudi Arabia (2025) to supply the finest Egyptian crops and products to the Saudi market.',
        },
      },
    ],
  },
];

export const sectorBySlug = sectors.reduce((acc, s) => {
  acc[s.slug] = s;
  return acc;
}, {});
